import { Facebook, Phone, Mail, MapPin } from "lucide-react";
import { COMPANY } from "../lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A1628] text-white border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-baseline gap-2">
              <span className="text-white text-2xl md:text-3xl font-black tracking-tight">
                JL
              </span>
              <span className="text-white/60 text-sm font-semibold tracking-[0.25em] uppercase">
                Service
              </span>
            </div>
            <p className="mt-5 text-white/60 text-sm leading-relaxed max-w-sm">
              Lokal handyman og tømrer i {COMPANY.city}. Fra små reparationer
              til eksklusive træterrasser — udført med præcision.
            </p>
            <a
              href={COMPANY.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              className="mt-6 inline-flex items-center gap-2 text-white/80 hover:text-white border border-white/20 hover:border-white px-4 py-2.5 text-xs uppercase tracking-[0.2em] font-bold transition-colors"
            >
              <Facebook size={14} />
              Følg os på Facebook
            </a>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 font-bold mb-5">
              Kontakt
            </div>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-white/50 mt-0.5 shrink-0" />
                <div>
                  <div className="font-bold">{COMPANY.owner}</div>
                  <div className="text-white/60">{COMPANY.city} · Østjylland</div>
                </div>
              </li>
              <li>
                <a
                  href={`tel:${COMPANY.phoneRaw}`}
                  data-testid="footer-phone-link"
                  className="flex items-center gap-3 text-white/80 hover:text-white transition-colors"
                >
                  <Phone size={16} className="text-white/50" />
                  {COMPANY.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  data-testid="footer-email-link"
                  className="flex items-center gap-3 text-white/80 hover:text-white transition-colors break-all"
                >
                  <Mail size={16} className="text-white/50 shrink-0" />
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Sitemap */}
          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 font-bold mb-5">
              Navigation
            </div>
            <ul className="space-y-3 text-sm">
              {[
                { href: "#services", label: "Ydelser" },
                { href: "#portfolio", label: "Portfolio" },
                { href: "#om", label: "Om Johnny" },
                { href: "#kontakt", label: "Kontakt" },
              ].map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                    className="text-white/70 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/40">
          <div>
            © {new Date().getFullYear()} {COMPANY.name} · {COMPANY.owner}. Alle rettigheder forbeholdes.
          </div>
          <div>CVR: 46147154 · Lokal håndværker i {COMPANY.city}</div>
        </div>
      </div>
    </footer>
  );
}
